<template>
  <q-layout view="lHh Lpr lFf" id="app" class="wrapper">
    <TheSiteNavigation v-if="this.signedIn" :routes="routes" />
    <q-page-container class="wrapper__container">
      <q-inner-loading :showing="this.loading">
        <q-spinner size="50px" color="secondary" />
        <div class="wrapper__loader-text">Please wait...</div>
      </q-inner-loading>
      <div v-if="this.loaded">
        <div v-if="this.signedIn">
          <router-view :key="$route.fullPath" class="wrapper__background" />
        </div>
        <Login v-else />
      </div>
    </q-page-container>
  </q-layout>
</template>

<script>
import { Auth, Hub } from "aws-amplify";
import axios from "axios";
import TheSiteNavigation from "@/components/global/TheSiteNavigation.vue";
import backgroundImage from "@/assets/markortech-bg.svg";
import { getRoutes, orderForNavigation } from "./router/utils";
import { COMPONENTS_MAPPING } from "./router/constants";
import { routes } from "./router";

import Login from "@/views/Login.vue";

export default {
  name: "TheAppWrapper",
  components: {
    TheSiteNavigation,

    Login,
  },

  data() {
    return {
      loaded: false,
      loading: true,
      signedIn: false,
      backgroundImage: `url(${backgroundImage})`,
      routes: [],
    };
  },

  created() {
    this.loadUserApplication();

    // Action happens when not signed in
    Hub.listen("auth", (data) => {
      const { payload } = data;

      this.loading = true;

      if (payload.event === "signIn") {
        this.loadUserApplication();
      }
      if (payload.event === "signOut") {
        window.location = window.location.origin;
      }
    });
  },
  methods: {
    async loadUserApplication() {
      return Promise.all([this.getUserDetails(), this.getRoutingData()])
        .then((result) => this.hydrateApplication(result))
        .then(() => {
          this.signedIn = true;
          this.loaded = true;
          this.loading = false;
        })
        .catch((error) => {
          this.signedIn = false;
          this.loaded = true;
          this.loading = false;
          console.log("Loading User Application", error);
        });
    },
    async getRoutingData() {
      return Promise.all([
        this.getPages(),
        this.getCategories(),
        this.getNavigationOrdering(),
      ]);
    },
    async getUserDetails() {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const { data } = await axios.get(`/api/users/${user.attributes.email}`);
        return data;
      } catch (error) {
        console.error("Get User Details:", error);
      }
    },
    async getPages() {
      try {
        const { data } = await axios.get("/json/pages.json");
        return data;
      } catch (error) {
        console.error("Get Dynamic Pages:", error);
      }
    },
    async getCategories() {
      try {
        const { data } = await axios.get("/json/categories.json");
        return data;
      } catch (error) {
        console.error("Get Dynamic Categories:", error);
      }
    },
    async getNavigationOrdering() {
      try {
        const { data } = await axios.get("/json/order.json");
        return data;
      } catch (error) {
        console.error("Get Dynamic Navigation Ordering:", error);
      }
    },
    hydrateApplication([userDetails, [pages, categories, order]]) {
      this.$store.commit("SET_USER_DETAILS", { userDetails });

      const userRoles = userDetails.role_functions;
      // Role ID's used for b2b(79) and b2c(78) roles
      const expectedUserRoles = [78, 79];
      const matchedUserRoles = userRoles.filter((role) =>
        expectedUserRoles.includes(role)
      );
      this.$store.commit("SET_USER_TYPE_ROLE", [...matchedUserRoles]);

      const dynamicRoutes = getRoutes(
        userDetails.role_functions,
        pages,
        categories,
        COMPONENTS_MAPPING
      );

      //dynamic routes Roadmap Link update for DR technology users
      const drUsers = [
        "stmi@gcsops.com",
        "csmd@gcsops.com",
        "amoolya@gmail.com",
      ];
      const isDrUser = drUsers.some((user) => user === userDetails.email);
      dynamicRoutes.forEach((route) => {
        if (route.name === "Roadmap" && isDrUser) {
          route.meta.link =
            "https://sharing.clickup.com/6616990/gr/h/69xwy-10345/704851605cf5da2";
        }
      });

      //otherwise load the defaults
      this.$router.addRoutes(dynamicRoutes);
      this.routes = orderForNavigation([...routes, ...dynamicRoutes], order);
    },
  },
};
</script>
<style lang="scss">
.wrapper {
  overflow-x: hidden;
  background: #f5f6f8;
  font-family: "Barlow", sans-serif;
  &__background {
    background-image: url("~@/assets/bg.svg");
    // background-repeat: no-repeat;
    // background-position: center;
    // background-size: cover;
    background-attachment: fixed;
  }
  &__loader-text {
    margin-top: 1em;
    font-weight: 600;
    font-size: 14px;
    line-height: 14px;
  }
}

// Dark Mode
.body {
  &--dark {
    .wrapper {
      background: #1e1e1e;
      &__background {
        background-image: url("~@/assets/bg-dark.png");
        // background-repeat: no-repeat;
        // background-position: center;
        background-size: cover;
      }
    }
  }
}
.app-loader-text {
  margin-top: 1em;
  font-weight: 600;
  font-size: 14px;
  line-height: 14px;
}
</style>
